// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"_4-z","dimensionLabel":"a5-z","styleChooserControlWrapper":"b5-z","styleChooserControl":"c5-z","disabled":"d5-z","giftCard":"e5-z","styleChooserText":"f5-z"};